module.exports = __webpack_public_path__ + "static/media/CustomerSegments.6b3a9517.png";